import * as React from 'react';

import { useFormContext } from 'react-hook-form';

import FormControl from '@mui/material/FormControl';

import { Controller } from "react-hook-form"

import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { TimePicker } from '@mui/x-date-pickers/TimePicker';



export default function FormTimePicker({name,label,required,rules = {},...props}) {

    const {control, watch } = useFormContext();

	const requiredDefaultRule = required ? { required: { value: true, message: "This field is required" } } : {};
	rules = { ...requiredDefaultRule, ...rules };

    const watchValue = watch(name);

    return (
        <Controller
            render={({field})=><LocalizationProvider dateAdapter={AdapterDayjs}>
              <FormControl fullWidth>
                <TimePicker label={label} value={watchValue} {...field} />
              </FormControl>
            </LocalizationProvider>}
            name={name}
            control={control}
            rules={rules}
        />
    );
};
